import { TrackEvent } from './trackingHelpers'

// Content interaction event
export interface ContentInteractionProps {
  interactionType: string
  blockName: string
  clickText: string
  fileName?: string | null
}

export function ContentInteractionEvent(
  trackingProps: ContentInteractionProps,
) {
  TrackEvent('content_interaction', trackingProps)
}
